import React, { useState, useEffect } from "react";
import { Tooltip, Typography, Slider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { Link } from "react-router-dom";
import "../css/MapRightSideBar.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateForm } from "../state/calculator";

function MapRightSideBar(props) {
  const title = "Compare to Base";
  const {
    currentProperty,
    stateTaxes,
    federalTaxes,
    years,
    ageArray,
  } = props.redux;

  const [mock10, setMock10] = useState([]);
  const [baseArray, setBaseArray] = useState([]);
  const [activeArray, setActiveArray] = useState([]);
  const [activeSideObject, setActiveSideObject] = useState({
    AnnualSaveCompToBase: null,
    EstAnnualStateLocalIncomeTax: null,
    EstimatedYearlyCost: null,
    HOA: 0,
    HOAIndex: 1,
    HealthInsIndex: 1,
    HealthInsurance: 0,
    HomeInsIndex: 1,
    HomeInsurance: 0,
    ModelIndex: 1,
    PNIindex: 4,
    PlanYear: 0,
    PrincipalNInterest: 0,
    PropTaxIndex: 0,
    PropertyTax: 0,
    SnLocTaxIndex: 0,
  });

  const [activeIndex, setActiveIndex] = useState(0);
  const [activeYear, setActiveYear] = useState(ageArray[0]);

  const useStyles = makeStyles((theme) => ({
    root: {
      // width: "80%",
    },
    margin: {
      height: theme.spacing(3),
    },
  }));

  const handleSliderChange = (value) => {
    setActiveYear(value);
  };

  const classes = useStyles();

  useEffect(() => {
    setActiveIndex(currentProperty.Prop_id);
  }, [currentProperty]);

  useEffect(() => {
    let dat = localStorage.getItem("mock10");
    let parsedDat = JSON.parse(dat);
    setMock10(parsedDat);
  }, []);

  useEffect(() => {
    if (props.redux.tenYear !== [] && props.redux.tenYear !== mock10) {
      setMock10(props.redux.tenYear);
    }
  }, [props.redux.tenYear]);

  useEffect(() => {
    let tempArray = [];
    let tempBaseArray = [];
    let tmpIndex;

    ageArray.map((age, indx) => {
      if (age === activeYear) {
        tmpIndex = indx;
      }
    });

    mock10.map((mock) => {
      if (mock.prop_id === activeIndex) {
        tempArray.push(mock);
      }
    });
    mock10.map((mock) => {
      if (mock.prop_id === 0) {
        tempBaseArray.push(mock);
      }
    });
    setActiveArray(tempArray);

    if (tempArray.length > 0) {
      setActiveSideObject(tempArray[tmpIndex]);
      props.updateForm({
        id: "activePropertyObject",
        value: tempArray[tmpIndex],
      });
      props.updateForm({ id: "activeYearIndex", value: tmpIndex });
    }
    setBaseArray(tempBaseArray);
  }, [mock10, activeIndex, currentProperty, activeYear]);

  return (
    <div
      className="mapRightSideBarWrapper"
      style={
        props.backgroundStyle === true
          ? props.activeBackground
          : props.inactiveBackground
      }
    >
      <React.Fragment>
        <div className={classes.root}>
          <Typography id="discrete-slider-always" gutterBottom>
            Select Age
          </Typography>
          <Slider
            defaultValue={ageArray[0]}
            aria-labelledby="discrete-slider-small-steps"
            step={1}
            min={ageArray[0]}
            max={ageArray[9]}
            valueLabelDisplay="on"
            getAriaValueText={handleSliderChange}
          />
        </div>

        <div className="basicHomeCosts">
          <div className="rightMapSection">
            <Tooltip title="This is the real-estate price on the market for the home in 2020.">
              <p>
                <strong>Cost: </strong>
                {currentProperty.CurrentPrice}
              </p>
            </Tooltip>
          </div>
          <div className="rightMapSection">
            <p>
              <strong>Principal & Interest: </strong>

              {activeSideObject.PrincipalNInterest}
            </p>
          </div>
          <div className="rightMapSection">
            <p>
              <strong>HOA fees: </strong> {activeSideObject.HOA}
            </p>
          </div>
          <div className="rightMapSection">
            <p>
              <strong>Property Tax: </strong>
              {activeSideObject.PropertyTax}
              /mo
            </p>
          </div>
          <div className="rightMapSection">
            <p>
              <span>Home Insurance: </span>

              {activeSideObject.HomeInsurance}
            </p>
          </div>
        </div>
        <div className="specialistInfo">
          <div className="rightMapSection">
            <p>
              <strong>Health Insurance (Monthly)</strong>
            </p>
            <p className="blueFont">{activeSideObject.HealthInsurance}</p>
          </div>
          <div className="rightMapSection">
            <p>
              <span>Estimated Resident Income Tax: </span>
              {activeSideObject.EstAnnualStateLocalIncomeTax || "Unknown"}
              /yr
            </p>
          </div>
          <div className="rightMapSection">
            <p>
              <strong>Estimated Yearly Cost: </strong>
              {activeSideObject.EstimatedYearlyCost || "Unknown"}
            </p>
          </div>
          <div className="rightMapSection">
            <p>
              <strong>Annual Savings Compared to Base: </strong>

              {activeSideObject.AnnualSaveCompToBase || "Unknown"}
            </p>
          </div>
        </div>
        <div className="header">
          <h1>
            <strong>
              <Link to="/estimator">{title}</Link>
            </strong>
          </h1>
        </div>
      </React.Fragment>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    redux: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateForm: (formData) => updateForm(formData),
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MapRightSideBar);
